let interactiveLoginPending = false

export const markUsFebConsentInteractiveLogin = (): void => {
  interactiveLoginPending = true
}

export const consumeUsFebConsentInteractiveLogin = (): boolean => {
  const pending = interactiveLoginPending
  interactiveLoginPending = false
  return pending
}
